// extracted by mini-css-extract-plugin
export default {"webapp_container":"webApp_webapp_container__TV7x4"};